import React from "react";
import { Box, makeStyles, Typography } from "@material-ui/core";
import SliderComponent from "../StaticComp/SliderComponent/SliderComponent";
import { useSelector } from "react-redux";

export default function TitleAndTradingSlider() {
  const classes = useStyles();
  const prices = useSelector((state) => state.sliderChange.price);

  function formatNumber(num) {
    var n1, n2;
    num = num + "" || "";
    // works for integer and floating as well
    n1 = num.split(".");
    n2 = n1[1] || null;
    n1 = n1[0].replace(/(\d)(?=(\d\d)+\d$)/g, "$1,");
    num = n2 ? n1 + "." + n2 : n1;
    return num == "NaN" ? "" : num;
  }

  return (
    <>
      <div className="flex justify-between w-full items-center">
        <Box display="flex">
          <p className="opacity-80">Average Monthly Trading</p>
        </Box>
        <Typography
          display="block"
          variant="h5"
          className={classes.oneThousand}
        >
          <strong>₹{formatNumber(prices)}</strong>
        </Typography>
      </div>
      <div className="flex justify-between w-full items-center">
        <div className="w-full">
          <SliderComponent />

          <Box display="flex" color="#888" justifyContent="space-between">
            <Typography variant="overline" className={classes.oneThousandFlex}>
              ₹1000
            </Typography>
            <Typography variant="h5"></Typography>
            <Typography variant="overline" className={classes.oneThousandPlus}>
              ₹1 Crore+
            </Typography>
          </Box>
        </div>
      </div>
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  avgMonthlyTrading: {
    fontWeight: 100,
    flex: 1,
    textAlign: "left",
    marginBottom: "20px",
  },
  checkboxes: {
    marginBottom: "50px",
  },
  oneThousand: {
    textAlign: "center",
    // marginLeft: "55%",
  },
  oneThousandFlex: {
    textAlign: "left",
    flexGrow: "1",
    // marginLeft: "55%",
  },
  oneThousandPlus: {
    // marginLeft: "80%",
  },
}));
